























































































































































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import ChartProgress from './ChartProgress.vue'
import ExamSkillReport from './ExamSkillReport.vue'
import ExamSkillItemReport from './ExamSkillItemReport.vue'
import ExamEvaluationComponent from './ExamEvaluation.vue'
import ExamResultQuestionGroupList from './ExamResultQuestionGroupList.vue'
import Exam from '../../models/exam'
import {LETTER_FORMAT} from '../../utils/constants'
import {GroupQuestion} from '../../../api/v2/models/question'
import FbShareButton from './FbShareButton.vue'
import TwShareButton from './TwShareButton.vue'
import {headerState} from '../../stores/header'
import {footerState} from '../../stores/footer'
import UserExam from '../../models/user_exam'
import Banner from '../../../api/v2/models/banner'
import {ExamQScoreHistory} from '../../../api/v2/models/q_score_history'
import MesageContainer from "../organisms/MesageContainer.vue";
import ThreadContainer from "../organisms/ThreadContainer.vue";
import {Multipane, MultipaneResizer} from 'vue-multipane'
import SkillsChart from "./SkillsChart.vue";

@Component({
  components: {
    SkillsChart,
    ThreadContainer,
    MesageContainer,
    ChartProgress,
    ExamSkillReport,
    ExamSkillItemReport,
    ExamResultQuestionGroupList,
    FbShareButton,
    TwShareButton,
    ExamEvaluationComponent,
    Multipane,
    MultipaneResizer,
  }
})
export default class ExamResultWeb extends Vue {
  @Prop({required: true}) exam!: Exam
  @Prop({required: true}) userExam!: UserExam
  @Prop({required: false}) banners!: Banner[]
  @Prop({required: true}) groupQuestions!: GroupQuestion[]

  @Prop({default: null})
  examQScoreHistory!: ExamQScoreHistory | null

  LETTER_FORMAT = LETTER_FORMAT

  tab: number | null = null
  bodyTab: number | null = this.exam.isShowEvaluation  ? 0 : 1
  resizeOb: ResizeObserver = null

  updated() {
    this.$nextTick(function () {
      if (this.resizeOb) return

      const observeSidebar = () => {
        const rightSideBar = this.$refs.rightSideBar as HTMLElement
        const rightSideBarCard = this.$refs.rightSideBarCard as any
        this.resizeOb = new ResizeObserver(function(entries) {
          let rect = entries[0].contentRect;
          let width = rect.width;
          rightSideBarCard.$el.style.width = `${width}px`
        })
        this.resizeOb.observe(rightSideBar)
      }

      const retryObserveSidebar = () => {
        try {
          observeSidebar()
        } catch (error) {
          setTimeout(retryObserveSidebar, 500)
        }
      }

      setTimeout(retryObserveSidebar, 500)
    })
  }

  beforeUnmount() {
    const rightSideBar = this.$refs.rightSideBar as HTMLElement
    this.resizeOb.unobserve(rightSideBar)
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  get skills() {
    return this.exam.examSkills
  }

  get shareUrl() {
    return `${window.location.origin}/exams/${this.exam.id}`
  }

  get shareText() {
    return `
    ${this.userExam.passed ? '合格しました！' : '残念ながら不合格です'}\n
    正解率: ${this.userExam.average}%\n
    平均: ${this.exam.averageRate}%\n
    順位: ${this.userExam.position}位\n
    `
  }

  get sortedGroupQuest() {
    return this.groupQuestions.sort((a, b) => a.groupId - b.groupId)
  }

  get useAiChatExam() {
    if(!this.schoolSetting) {
      return false
    }

    return this.schoolSetting.useAiChatExam
  }

  getQuestionNumber(groupExamResultQuestion) {
    return (
        this.groupQuestions
            .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
            .indexOf(groupExamResultQuestion) + 1
    )
  }

  async mounted() {
    if(!headerState.schoolSetting) {
      await headerState.getSchoolSetting()
    }

    headerState.setTitle(this.exam.name)
    footerState.setFooterDefault()
  }

  updateParentTab(value: number) {
    this.tab = value
  }

  emitCreateThread(value: number) {
    if (typeof value === 'number') {
      this.tab = value;
    }
    (this.$refs.mesageContainer as any).createThread()
  }

  getBanner(position) {
    var result = this.banners.find((banner) => {
      return banner.position == position
    })
    return result
  }
}
